<script setup>
// §8.2 ErrorState — what happened + how to fix. Never vague, never apologetic
// (§9). "This entry overlaps 2:00–2:30pm, already captured for Meridian Legal",
// not "Something went wrong". Uses the rejected hue as a graphical marker only;
// the message carries the meaning.
import LIcon from '../base/Icon.vue'
</script>

<template>
  <div class="l-error" role="alert">
    <LIcon name="circle-exclamation" class="ic" :size="20" aria-hidden="true" />
    <div class="body">
      <h4 class="t"><slot name="title" /></h4>
      <p class="fix"><slot name="fix" /></p>
      <div v-if="$slots.action" class="a"><slot name="action" /></div>
    </div>
  </div>
</template>

<style scoped>
.l-error {
  display: flex;
  gap: var(--sp-3);
  padding: var(--sp-4);
  background: var(--status-rejected-fill);
  border: 1px solid color-mix(in srgb, var(--status-rejected-text) 22%, transparent);
  border-radius: var(--r);
}
.ic {
  color: var(--status-rejected-text);
  flex: none;
  margin-top: 1px;
}
.t {
  font-size: var(--text-base);
  font-weight: 600;
  color: var(--text);
}
.fix {
  font-size: var(--text-sm);
  color: var(--text-2);
  margin-top: 3px;
  line-height: 1.5;
}
.a {
  margin-top: var(--sp-3);
}
</style>
